"use client";

import { Download, FileUp, Settings } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";

interface StepItemProps {
	icon: React.ReactNode;
	title: string;
	description: string;
}

function StepItem({ icon, title, description }: StepItemProps) {
	return (
		<div className="bg-slate-50 rounded-lg p-8 shadow-sm hover:shadow-md transition-all duration-200">
			<div className="flex gap-4">
				<div className="flex-1">
					<div className="flex items-center gap-3 mb-4">
						{icon}
						<h3 className="font-medium text-lg">{title}</h3>
					</div>
					<p className="text-slate-600 text-sm leading-relaxed">
						{description}
					</p>
				</div>
			</div>
		</div>
	);
}

export function ProcessSteps() {
	const t = useTranslations("imageToPrompt.processSteps");
	const locale = useLocale();

	return (
		<div className="w-full my-16">
			<div className="mb-8">
				<h2
					className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-indigo-500 to-purple-600 bg-clip-text text-transparent"
					key={`title-${locale}`}
				>
					{t("title")}
				</h2>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					<StepItem
						icon={<FileUp className="h-6 w-6 text-indigo-500" />}
						title={t("upload.title")}
						description={t("upload.description")}
					/>

					<StepItem
						icon={<Settings className="h-6 w-6 text-indigo-500" />}
						title={t("select.title")}
						description={t("select.description")}
					/>

					<StepItem
						icon={<Download className="h-6 w-6 text-indigo-500" />}
						title={t("download.title")}
						description={t("download.description")}
					/>
				</div>
			</div>
		</div>
	);
}
